import styled from "styled-components";

export const StyledWrapper = styled.div`
  > div {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    gap: 4px;
    white-space: nowrap;

    > div {
      width: min-content;
      min-width: 48px;
    }
  }

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
    margin-top: -12px;
  }
`;
